import React, { forwardRef } from 'react'
import { Link as ReachLink } from '@reach/router'

import addTrailingSlashToPath from 'utils/addTrailingSlashToPath'

const Link = forwardRef(({ to, ...props }, ref) => (
  <ReachLink ref={ref} to={addTrailingSlashToPath(to)} {...props} />
))

export default Link
